import React, { Component } from 'react'
import Link from 'gatsby-link'
import OneImage from '../assets/images/oneWhite.png'
import TwoImage from '../assets/images/two.png'
import ThreeImage from '../assets/images/three.png'

class HowItWorks extends Component {
    render() {
        return(
            <section>
                <div className="container">
                    <div className="columns">
                        <div className="column"></div>
                        <div className="column is-half">
                            <div className="content m-t-xl">
                                <p className="is-size-3 has-text-centered has-text-weight-bold">How It Works</p>
                            </div>
                            <div className="content">
                                <p className="is-size-5 has-text-centered">It's simple. We plan a great party, you provide the food and friends.</p>
                            </div>
                        </div>
                        <div className="column"></div>
                    </div>
                    <div className="columns">                        
                        <div className="column m-t-xl has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={OneImage} /></p>
                            <p className="is-size-4">Pick a Bundle.</p>
                        </div>
                        <div className="column m-t-xl has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={TwoImage} /></p>
                            <p className="is-size-4">We'll Ship it Straight to You</p>
                        </div>
                        <div className="column m-t-xl  has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={ThreeImage} /></p>
                            <p className="is-size-4">Host a Great Party!</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


export default HowItWorks


// WEBPACK FOOTER //
// ./src/components/howItWorks.js